// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"fa7b3afc","917":"6458b392"}[chunkId] + ".chunk.js";
};